import User from 'records/User';
import React from 'react';
import {UserAvatar} from '@components/util/UserAvatar';
import './GumUserInfoBox.styl';
import {TimezoneAutocomplete} from 'components/pure/admin/TimezoneAutocomplete';
import FieldContainer from 'components/pure/utils/form/FieldContainer';

export default function GumUserInfoBox(props: {
  user: User;
  userZoneFunction: (tz: string) => void;
  userZoneErrorCode?: string;
  isAdminEdit?: boolean;
}) {
  const user = props.user;
  const isAdminEdit = props.isAdminEdit ?? false;

  return (
    <>
      {isAdminEdit && <h4 className="gum-profile-title">Global User Details</h4>}
      <div className="gum-profile-box form-grouper">
        <div className="gum-first-row-form">
          <div className="gum-first-name">
            <p className="gum-field-name">First name</p>
            <b>{user.firstName}</b>
          </div>
          <div className="gum-avatar">
            <UserAvatar user={user} />
          </div>
        </div>
        <div>
          <p className="gum-field-name">Last name</p>
          <b>{user.lastName}</b>
        </div>
        <div>
          <p className="gum-field-name">Email</p>
          <b>{user.email}</b>
        </div>
        <div>
          <FieldContainer label="Timezone" className="new-timezone" error={props.userZoneErrorCode}>
            <TimezoneAutocomplete
              value={user.timezone}
              setUserZone={tz => {
                props.userZoneFunction(tz);
              }}
              className="white-background"
            />
          </FieldContainer>
        </div>
      </div>
    </>
  );
}
